import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import ImageContainer from "@components/ImageContainer";
import HeroDekstopImage from "./img/hero-dekstop.webp";
import HeroMobileImage from "./img/hero-mobile.webp";
import QrImage from "./img/qr.webp";
import ScannerImage from "./img/scanner.webp";
import SurveyImage from "./img/survey.webp";
import PagesHeader from "@components/PagesHeader";
import Button from "@components/Button";
import SectionHeader from "@components/SectionHeader";
import LockIcon from "./img/lock-icon.svg";
import QrIcon from "./img/qr-icon.svg";
import "./style.scss";
import NiceModal from "@ebay/nice-modal-react";
import { packStats } from "@api/pack";
import { startWebSession, trackWebEvent } from "@api/web";

const CARD_DATA = [
  {
    img: QrImage,
    title: <>QR-Code finden</>,
    desc: (
      <>
        Such den einzigartigen QR‑Code auf deiner Vuse Ultra Pod Verpackung. Der
        QR-Code wird nach dem Öffnen auf der Innenseite sichtbar.
      </>
    ),
  },
  {
    img: ScannerImage,
    title: <>Mit der Kamera scannen</>,
    desc: (
      <>
        Klick auf „Code scannen“, erlaube den Kamerazugriff und richte deine
        Kamera auf den QR‑Code.
      </>
    ),
  },
  {
    img: SurveyImage,
    title: <>Dein Feedback teilen</>,
    desc: (
      <>
        Durch den QR‑Scan öffnet sich eine kurze Umfrage. Beantworte ein paar
        wenige Fragen <strong>und sichere dir sofort Punkte.</strong>
      </>
    ),
  },
];

function Spacer() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="218"
      height="1"
      viewBox="0 0 218 1"
      fill="none"
      preserveAspectRatio="none"
      style={{ width: "100%" }}
    >
      <path d="M218 0V1H0V0H218Z" fill="url(#paint0_linear_5438_54412)" />
      <defs>
        <linearGradient
          id="paint0_linear_5438_54412"
          x1="0"
          y1="0.5"
          x2="218"
          y2="0.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47B5BF" stopOpacity="0.08" />
          <stop offset="0.5" stopColor="#47B5BF" />
          <stop offset="1" stopColor="#47B5BF" stopOpacity="0.08" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default function QrScannerLanding() {
  const { data: stats } = useQuery({
    queryKey: ["pack-stats"],
    queryFn: packStats,
    retry: false,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  const scansMonth = stats?.pack?.month ?? "–";
  const limitExceeded = stats?.pack?.limitExceeded ?? false;

  const resetAt = (() => {
    const now = new Date();
    return new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      1,
    ).toLocaleDateString("de-DE", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  })();

  function handleButtonClick() {
    startWebSession(() => {
      trackWebEvent("scanner_open", {});
    });
    NiceModal.show("qr-scanner-modal");
  }

  return (
    <section className="qr-scanner-page">
      <PagesHeader>
        <strong>Vuse</strong> Umfrage
      </PagesHeader>
      <ImageContainer desktopImg={HeroDekstopImage} mobileImg={HeroMobileImage}>
        <div className="hero-info-wrapper">
          <div className="box">
            <p>
              Scanne den einzigartigen Code auf deiner Vuse (Ultra)
              Pod-Verpackung, um an unserer Umfrage teilnehmen zu können.
              Beantworte ein paar wenige Fragen und sichere dir sofort Punkte.
            </p>
            <Button
              action={handleButtonClick}
              btnClass="ultra-insider"
              disabled={limitExceeded}
            >
              Code Scannen
            </Button>
          </div>
          <div className="box flex-row">
            <div className="inner-content">
              <p>Umfrage-Teilnahme diesen Monat</p>
              <div className="progress">
                <span className="status">{scansMonth}/5</span>
                <span>Scans genutzt</span>
              </div>
              <Spacer />
              <p className="reset-info">
                Wird zurückgesetzt am:
                <br /> <span>{resetAt}</span>
              </p>
            </div>
            <img src={limitExceeded ? LockIcon : QrIcon} alt="" />
          </div>
        </div>
      </ImageContainer>

      {/* <SectionHeader>
        <span className='pre'>So sammelst du</span> <span className='post'>Punkte</span>
      </SectionHeader> */}

      <div className="cards-wrapper">
        {CARD_DATA.map((card, index) => (
          <div className="card" key={index}>
            <img src={card.img} alt="" />
            <div className="card-desc">
              <p className="title">{card.title}</p>
              <Spacer />
              <p>{card.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
